export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-simple-flow/index.js